<template>
<div>
    <!-- <headerComponent/> -->
    <div class="pageContainer">
        <!-- <carousel :perPage="1" :autoplay="true" :loop="true" style="height:540px">  
            <slide v-for="image in images" :key="image">  
                <img :src="require(`${image}`)" alt="carousel image">  
            </slide>  
        </carousel>   -->

        <img :src="curImg.src" alt="" srcset="" style="width:100%;"  class="animate__animated animate__slideInLeft">

    </div>
    <div class="containerOne" style="position:relative;width:100%;height:910px;margin:45px 0 0 0">
      <img src="@/views/aboutUs/images/group01.png" alt="" srcset="" style="width:1458px;position:absolute;right:10px;z-index:1">
       <img v-animate-onscroll="'animate__animated animate__fadeInLeft'" src="@/views/aboutUs/images/FX.png" alt="" srcset="" style="width:1280px;position:absolute;z-index:3;left:0;top:0px">
       <div class="wordsOne" v-animate-onscroll="'animate__animated animate__fadeInRight'">
        <span>This is a journey about color, starting with technology and ending with quality. </span>
        <span>Each product, from the beginning has a unique color attribute,</span>
        <span>through the baptism of layers of processes, every detail is accurate control;</span>
        <span>The blessing of scientific and technological power makes the products more beautiful,</span>
        <span>durable and environmentally friendly.</span>
        <span>Along the way, the quality has always been solid as a rock.</span>
        <span>Across thousands of mountains and rivers to meet you.</span>
        <span>With our color, our quality, our technology,</span>
        <span>to bring you a different color visual performance.</span>
        <span>More comprehensive care and experience.</span>
        <span>Hello, world.</span>
        <span>We can be better together.</span>
       </div>
    </div>
    <!-- <footerComponent/> -->
    <div class="containerTwo" style="width:1460px;padding:10px 45px;margin:0 auto;margin-bottom:20px;height:600px">
      <div class="company">
        <img src="./images/bgLogo01.png" alt="" srcset="" width="100%" style="position:absolute;z-index:1;">
        <div style="width:100%;height:100%" ref="box">
          <div class="logoContain">
            <span class="logoTit" style="left:60px">1995</span>
            <span class="logoWord" style="left:90px;">Founded the brand in 1995</span>
          </div>

          <div class="logoContain">
            <span class="logoTit" style="left:120px">28</span>
            <span class="logoWord" style="left:100px;">28 years of quality as solid as a rock</span>
          </div>

          <div class="logoContain">
            <span class="logoTit" style="left:60px">4200</span>
            <span class="logoWord" style="left:90px;">The annual output is 4200 tons</span>
          </div>

          <div class="logoContain">
            <span class="logoTit" style="left:60px">26000</span>
            <span class="logoWord" style="left:80px;">26000 flat garden-style industrial park</span>
          </div>
          <div class="clearBoth"></div>
          
        </div>
        <div class="words">
            <span>
              YOULIMEI, an international high-tech enterprise full of enthusiasm and passion, has a long history of birth, and now it is showing its brilliance with its unique charm, just like a gem, shining in the beautiful and rich land of Qingdao!
            </span>
            <br/>
            <span>
              Nearly two decades of wind and rain temper, YOULIMEI has got rid of the green and immature, in Yantai Laiyang has an area of more than 26,000 square meters of garden-style industrial park. At present, YOULIMEI has a professional R & D team, involved in high-end powder coating R & D and sales, in Laiyang, Qingdao two established production bases and operation R & D center, we rely on a strong professional team, high standard quality system, perfect management system, rapid development in the industry, with quality service, sound sales network, Win the support and trust of the majority of partners.
            </span>
          </div>
      </div>

    </div>
    <div>

    </div>
    <div class="climeStyle" style="height:200px">
      <span class="climeTitle">
        DEVELOPMENT COURSE
      </span>
      <div style="margin:55px auto;width:1300px">
        <!-- 时间节点开始 -->
        <div class="block" style="position:absolute;z-index:99;color:#fff;width:100%;left:0">
          <div class="processBox">
            <div class="timelineProcessBox">
              <el-timeline class="timeline">
                <el-timeline-item
                  class="lineitem"
                  :class="activity.done ? 'active' : 'inactive'"
                  v-for="(activity, index) in activities"
                  :key="index"
                  :timestamp="activity.time"
                >
                  <span style="display: flex; flex-direction: column">
                    <span style="margin: 10px 0; font-size: 18px;color:#272a36;font-weight:300">
                      {{ activity.content }}
                    </span>
                  </span>
                </el-timeline-item>
              </el-timeline>
            </div>
          </div>
        </div>
        <!-- 时间节点结束 -->
      </div>
    </div>
    <div class="climeStyleBg"></div>
</div>
</template>
<script>
// import countTo from 'vue-count-to';
// import { Swiper } from 'swiper/vue';
import { timeline ,cate } from '@/api/index.js'
const self = this
export default {
  name: 'App',
   components:{
    // countTo
  },
  data() {  
    return { 
      curImg:{},
      activities : [
  {
    content: 'Founded the brand in LaiYang',
    time: '1995',
    people: '五六七',
    done: true,
  },
  {
    content: 'Set up Qingdao Company',
    people: '吉吉国王',
    done: false,
    time: '2003',
  },
  {
    content: 'Establishment of YOULIMEI Qingdao Headquarters',
    done: false,
    people: '熊大',
    time: '2017',
  },
  {
    content: 'Qingdao R & D Center put into use',
    people: '',
    done: false,
    time: '2024',
  }],
      timerId:null,
      timelineData:[
        "2020荣获最有价值企业",
        "青岛创新技术企业",
        "青岛优力美科技有限公司荣获高新企业认证",
        "青岛优力美科技有限公司未来无限可能"
      ],
      jjList: [
        {message: '2017',timelineData:[
        "荣获最有价值企业",
        "青岛创新技术企业",
        "青岛优力美科技有限公司未来无限可能"
        ]},
        {message: '2018',timelineData:[
        "荣获最有价值企业",
        "青岛创新技术企业",
        "青岛优力美科技有限公司荣获高新企业认证",
        "青岛优力美科技有限公司未来无限可能"
        ]},
        {message: '2019',timelineData:[
        "青岛优力美科技有限公司荣获高新企业认证",
        "青岛优力美科技有限公司未来无限可能",
        "年度优秀"
        ]},
        {message: '2020',timelineData:[
        "荣获最有价值企业",
        "青岛创新技术企业",
        "青岛优力美科技有限公司荣获高新企业认证",
        "青岛优力美科技有限公司未来无限可能"
        ]},
        {message: '2021',timelineData:[
        "荣获最有价值企业",
        "青岛创新技术企业",
        "青岛优力美科技有限公司荣获高新企业认证",
        "青岛优力美科技有限公司未来无限可能",
        ]},
        {message: '2022',timelineData:[
        "行业标兵",
        "青岛创新技术企业",
        "青岛优力美科技有限公司荣获高新企业认证",
        "青岛优力美科技有限公司未来无限可能"
        ]},
        {message: '2023',timelineData:[
        "青岛创新技术企业",
        "青岛优力美科技有限公司荣获高新企业认证",
        "青岛优力美科技有限公司未来无限可能"
        ]},
        {message: '2024',timelineData:[
        "荣获最有价值企业",
        "青岛优力美科技有限公司未来无限可能"
        ]},
        {message: '2025',timelineData:[
        "荣获最有价值企业",
        "青岛创新技术企业",
        "青岛优力美科技有限公司未来无限可能"
        ]},
        {message: '2026',timelineData:[
        "青岛创新技术企业",
        "荣获高新企业认证",
        "青岛优力美科技有限公司未来无限可能"
        ]}
      ],
    swiperOptions: {
        loop: true,
        allowTouchMove: false, 
        autoplay: {
          disableOnInteraction: false,
          delay: 2500
        },
        slidesPerView: 7, // 显示个数
        spaceBetween: 10,
        direction: 'horizontal',
        grabCursor: true,
        touchStartPreventDefault: false,
        on: {  
          slideChange: function () {  
            let jjList =[
              {message: '2017',timelineData:[
              "2017荣获最有价值企业",
              "青岛创新技术企业",
              "青岛优力美科技有限公司荣获高新企业认证",
              "青岛优力美科技有限公司未来无限可能"
              ]},
              {message: '2018',timelineData:[
              "2018荣获最有价值企业",
              "青岛创新技术企业",
              "青岛优力美科技有限公司荣获高新企业认证",
              "青岛优力美科技有限公司未来无限可能"
              ]},
              {message: '2019',timelineData:[
              "2019荣获最有价值企业",
              "青岛创新技术企业",
              "青岛优力美科技有限公司荣获高新企业认证",
              "青岛优力美科技有限公司未来无限可能"
              ]},
              {message: '2020',timelineData:[
              "2020荣获最有价值企业",
              "青岛创新技术企业",
              "青岛优力美科技有限公司荣获高新企业认证",
              "青岛优力美科技有限公司未来无限可能"
              ]},
              {message: '2021',timelineData:[
              "2021荣获最有价值企业",
              "青岛创新技术企业",
              "青岛优力美科技有限公司荣获高新企业认证",
              "青岛优力美科技有限公司未来无限可能"
              ]},
              {message: '2022',timelineData:[
              "2022行业标兵",
              "青岛创新技术企业",
              "青岛优力美科技有限公司荣获高新企业认证",
              "青岛优力美科技有限公司未来无限可能"
              ]},
              {message: '2023',timelineData:[
              "2023荣获最有价值企业",
              "青岛创新技术企业",
              "青岛优力美科技有限公司荣获高新企业认证",
              "青岛优力美科技有限公司未来无限可能"
              ]},
              {message: '2024',timelineData:[
              "2024荣获最有价值企业",
              "青岛创新技术企业",
              "青岛优力美科技有限公司荣获高新企业认证",
              "青岛优力美科技有限公司未来无限可能"
              ]},
              {message: '2025',timelineData:[
              "2025荣获最有价值企业",
              "青岛创新技术企业",
              "青岛优力美科技有限公司荣获高新企业认证",
              "青岛优力美科技有限公司未来无限可能"
              ]},
              {message: '2026',timelineData:[
              "2026荣获最有价值企业",
              "青岛创新技术企业",
              "青岛优力美科技有限公司荣获高新企业认证",
              "青岛优力美科技有限公司未来无限可能"
              ]}
            ]
            // timelineData = jjList[3].timelineData  
            



            // var activeIndex = this.activeIndex;  
  
            // var middleIndexOffset = Math.floor((this.params.slidesPerView - 1) / 2); 
            // var middleIndex = (activeIndex + middleIndexOffset) % this.slides.length; // 考虑循环  
        
            // if (this.params.slidesPerView % 2 === 0) {  
            //   var isFirstInMiddleGroup = activeIndex % this.params.slidesPerView < this.params.slidesPerView / 2;  
            //   middleIndex = isFirstInMiddleGroup ? activeIndex : activeIndex - 1;  
            //   if (middleIndex < 0) {  
            //     middleIndex = this.slides.length + middleIndex;  
            //   }  
            // }  
            // console.log('当前中间幻灯片的索引是:', middleIndex); 


          },  
          slideChangeTransitionEnd: function () {  
            console.log('幻灯片更改动画结束！');  
          },  
        }, 
        pagination: {
          el: '.swiper-pagination',
          clickable:true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },

      yearType:true
    };  
  }, 

  methods:{
    cateEvent() {
      cate().then((res)=>{
          this.curImg = this.filterItemsByPath('/#/aboutUs',res.data).banner[0]
      })
    },
    filterItemsByPath(path,arr) {
      let _arr = []
      let newArr = []
      _arr = arr
      newArr =  _arr.filter(item => item.path === path);
      if (newArr.length > 0) {
        return newArr[0]; // 只取第一个匹配的对象
      } else {
        return {}; // 如果没有匹配的对象，返回空对象
      }
  },
    handleScroll() {
      const boxRect =  this.$refs.box.getBoundingClientRect();
      if (boxRect.top <= window.innerHeight && boxRect.bottom >= 0&& this.yearType) {
        this.yearType = false;
        // 当box进入视窗时触发动画
        this.startAnimation();
      }
    },
    startAnimation() {
      this.$refs.year.start();
      this.$refs.year2.start();
      this.$refs.year3.start();
      this.$refs.year4.start();
      this.$refs.ton.start();
      this.$refs.ton2.start();
      this.$refs.square.start();
      this.$refs.square2.start();
    }
  },
  mounted() {  
    window.addEventListener('scroll',this.handleScroll);
   
    this.$nextTick(()=>{
      this.cateEvent()
       let _index = 3
    this.timerId = setInterval(() => {
     
      this.timelineData = this.jjList[_index ++].timelineData
      if(_index+1 == this.jjList.length) {
        _index = 0
      }
    }, 2500);
      timeline().then((res)=>{
        // alert(JSON.stringify(res))
      })
    })
    
    // this.swiperInstance = new Swiper('.swiper-container', {  
    //   on: {  
    //     slideChange: () => {  
    //       console.log('当前活跃的 slide 索引:', this.swiperInstance.activeIndex);  
    //     },  
    //     click: (event) => {  
    //       alert("kkkk")
    //       const clickedIndex = this.swiperInstance.clickedIndex; // 获取被点击 slide 的索引（如果有多个slide被同时点击，取第一个）  
    //       console.log('点击的 slide 索引:', clickedIndex);  
    //       // 你可以根据点击的索引执行更多操作  
    //     }  
    //   }  
    // });  
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
    if (this.timerId) {  
      clearInterval(this.timerId);  
      this.timerId = null;  
    } 
  }
}
</script>
<style lang="scss" scoped>
.wordsOne{
  font-weight: 200;
  position:absolute;
  right:140px;
  top:180px;
  z-index: 4;
  span {
    display: block;
    text-align: right;
    line-height: 40px;
    color: #272a36;
    letter-spacing: 1px;
  }
}
.company {
  // background: #fff url('./images/bgLogo01.png') no-repeat fixed center/cover padding-box content-box;
  position:relative;
  height: 320px;
}
.climeStyleBg {
  height:700px;
  width: 100%;
  background:  url('./images/clime.png') no-repeat top/cover padding-box content-box;
  background-size: 100% 100%;
  min-width: 1700px;
}
.climeStyle{
  // width: 100%;
  // background:  url('./images/clime.png') no-repeat top/cover padding-box content-box;
  // background-size: 100% 100%;
  .climeTitle{
    font-size:38px;
    font-weight: 700;
    text-align: center;
    display: block;
    margin:0 auto;
    letter-spacing: 1px;
  }

}
.logoContain{
  // text-align: center;
  position: relative;
  width: 25%;
  height: 100%;
  float:left;
  .logoTit{
    font-size:90px;
    color:#d32d25;
    display: block;
    letter-spacing: 1px;
    font-weight: 700;
    position:absolute;
    top:160px;
  }
  .logoWord {
    font-size: 14px;
    color:#272a36;
    display: block;
    position: absolute;
    bottom: 40px;
  }
}
.clearBoth {
  clear: both;
  line-height: 0;
  height: 0;
}

.words{
  line-height: 28px;
  span {
    display: block;
    font-size: 18px;
    color:#272a36;
    letter-spacing: 1px;
  }
}



.center-box {
  bottom:0;
      height: 130px;
      width: 100%;
      color: #FFFFFF;
      position: absolute;
      }
.card {
        //width: 250px;
        height: 130px;
        // background: #1B163F;
        // opacity: 0.3;
        display: flex;
        justify-content: space-around;
        align-items: center;
        color: #FFFFFF;
        font-size: 26px;
        }
::v-deep .swiper-button-next:after,
      .swiper-button-prev:after {
        display: none;
      }

      .arrow_left {
        width: 22px;
        height: 22px;
        transform: rotate(180deg);
        outline: none;
        border: 0;
        position: absolute;
        left: -40px;
      }

      .arrow_right {
        width: 22px;
        height: 22px;
        outline: none;
        border: 0;
        position: absolute;
        right: -40px;
      }



      .processBox {
      // background-color: #fff;
      // height: 210px;
    
      .title {
        font-size: 16px;
        font-weight: 600;
        padding-left: 32px;
        padding-top: 16px;
      }
      .timelineProcessBox {
        .timeline {
          display: flex;
          width: 95%;
          margin: 40px auto;
          .lineitem {
            transform: translateX(50%);
            width: 25%;
          }
        }
      }
    }
    
    :deep(.el-timeline-item__tail) {
      border-left: none;
      border-top: 2px solid #d32d25;
      width: 100%;
      position: absolute;
      top: 6px;
    }
    :deep(.el-timeline-item__wrapper) {
      padding-left: 0;
      position: absolute;
      top: 20px;
      transform: translateX(-50%);
      text-align: center;
    }
    :deep(.el-timeline-item__timestamp) {
      font-size: 14px;
      position: absolute;
      top:-70px;
      color:#272a36;
      font-size:24px;
      font-weight: 700;
      width:100%;
    }
    .active {
      :deep(.el-timeline-item__node) {
        background-color: #d32d25;
      }
      :deep(.el-timeline-item__tail) {
        border-color: #d32d25;
      }
    }
    有active样式的下一个li
    .active + li {
      :deep(.el-timeline-item__node) {
        background-color: #d32d25;
      }
    }

    ::v-deep .el-timeline-item__content {
      font-size: 18px;
    }

    ::v-deep .el-timeline-item__node {
      background-color: #d32d25;
    }
</style>
